import React, { useEffect, useState } from "react";
import { Icon } from "semantic-ui-react";
import "../stylesheets/genericMenu.css";

export default function GenericMenu({ menuItems }) {
    const [selectedMenuItem, setSelectedMenuItem] = useState(undefined);
    const [showMenuItem, setShowMenuItem] = useState(undefined);

    const onMenuItemClick = (path) => {
        const pathname = path.substring(1);
        let page = "";
        if (pathname) page = `/${pathname.split("/")[0]}`;
        setSelectedMenuItem({ path, page });
    };

    useEffect(() => {
        onMenuItemClick(typeof window !== "undefined" && window.location.pathname);
        document.body.addEventListener(
        "click",
        (e) => {
            const clickedTag = e?.target?.tagName.toLowerCase();
            const clickedClass = e?.target?.classList.value;
            if (!(clickedTag === "span" && clickedClass.includes("menuItem"))) {
            setShowMenuItem({ hover: undefined, click: undefined });
            }
        },
        true
        );
    }, []);

    useEffect(() => {
        setShowMenuItem({ hover: undefined, click: undefined });
    }, [selectedMenuItem]);

    const getHeaderMenuItem = (type, mi) => (
        <span className="menuItem" style={mi.nameColor ? { color: mi.nameColor } : {}}>
        {mi?.icon && <Icon name={mi.icon} />}
        {mi.name}
        {type === "submenu" && <Icon className="menuArrow angle down" fitted />}
        {mi?.animation && (
            <div
            style={{ display: "flex" }}
            className={mi?.animation?.class}
            ref={mi?.animation?.ref}
            />
        )}
        {mi?.extra && (
            <span
            style={{ background: mi?.extra?.backgroundColor }}
            className="header_item_meta header_menu_item_extra"
            >
            {mi?.extra?.name}
            </span>
        )}
        </span>
    );

    return (
        <div className="header-main__list">
        {menuItems.map((mi) =>
            mi?.submenu ? (
            <li
                className={`header-main__list-item ${
                selectedMenuItem?.page === mi.url && 
                // selectedMenuItem?.page === "/solving-for-india-hackathon" 
                mi?.submenu?.hideSelected
                ? "selected" : ""
                } ${mi?.class ? mi.class : ""} ${
                showMenuItem?.hover === mi.name || showMenuItem?.click === mi.name
                    ? "showDropdown"
                    : ""
                }`}
                key={mi.name}
                id={mi.id}
                onMouseEnter={() => {
                if (typeof window !== "undefined" && window.innerWidth >= 992) {
                    if (!(showMenuItem?.hover || showMenuItem?.click))
                    setShowMenuItem({
                        hover: mi.name,
                        click: undefined,
                    });
                }
                }}
                onMouseLeave={() => {
                setShowMenuItem({ ...showMenuItem, hover: undefined });
                }}
                onClick={() => {
                if (showMenuItem?.click === mi.name)
                    setShowMenuItem({ hover: undefined, click: undefined });
                else setShowMenuItem({ ...showMenuItem, click: mi.name });
                }}
            >
                {getHeaderMenuItem("submenu", mi)}
                <ui
                className={`mega-dropdown ${
                    showMenuItem?.hover === mi.name ||
                    showMenuItem?.click === mi.name
                    ? "showDropdown"
                    : ""
                }`}
                >
                {mi.submenu.map((msi) => (
                    <a
                    className={`mega-dropdown__list-item ${
                        selectedMenuItem?.path === msi.url ? "itemDisabled" : ""
                    }`}
                    key={msi.name}
                    id={msi.id}
                    href={msi.url}
                    style={{backgroundColor: msi.backgroundColor}}
                    onClick={(e) => {
                        if (selectedMenuItem?.path === msi.url)
                            e.preventDefault();
                        else {
                            const newURL = new URL(e.target.href);
                            if (newURL.pathname !== window.location.pathname) {
                                onMenuItemClick(newURL.pathname);
                            }
                        }
                    }}
                    >
                    <div className="mega-dropdown__list-item__child_container" >
                        <div className="name">{msi.name}</div>
                        {/* <div>{"extraIcon" in msi && msi.extraIcon}</div> */}
                        {msi.extra ? (<div>{msi.extra}</div>) : null}
                    </div>
                    </a>
                ))}
                </ui>
            </li>
            ) : (
                <a
                className={`header-main__list-item ${selectedMenuItem?.path === mi.url ? "itemDisabled" : ""} ${
                    mi?.class ? mi.class : ""
                }`}
                key={mi.name}
                id={mi.id}
                href={mi.url}
                onClick={(e) => {
                    if (selectedMenuItem?.path === mi.url) e.preventDefault();
                }}
                >
                {getHeaderMenuItem("menu", mi)}
                </a>
            )
        )}
        </div>
    );
}